import Alert from "@mui/material/Alert"
import AlertTitle from "@mui/material/AlertTitle"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"

export function PromptPoliciesGuidanceAlert() {
    return (
        <Alert severity="info" sx={{ mb: 3 }}>
            <AlertTitle>How this page works</AlertTitle>
            <List dense disablePadding sx={{ listStyleType: "disc", pl: 2.5 }}>
                <ListItem sx={{ display: "list-item", py: 0.25, pl: 0 }}>
                    <ListItemText
                        primary="Global prompt (default)"
                        secondary="Each card shows the global template and Global vN. Timestamps on the card are for the global prompt only."
                    />
                </ListItem>
                <ListItem sx={{ display: "list-item", py: 0.25, pl: 0 }}>
                    <ListItemText
                        primary="Effective / View prompts"
                        secondary="View effective prompt shows what the selected workspace uses. Compare shows global vs override side by side."
                    />
                </ListItem>
                <ListItem sx={{ display: "list-item", py: 0.25, pl: 0 }}>
                    <ListItemText
                        primary="Stale overrides"
                        secondary="Orange chips may show Stale when the global version moved past the version the override was forked from. Reset to global or Modify to fix."
                    />
                </ListItem>
                <ListItem sx={{ display: "list-item", py: 0.25, pl: 0 }}>
                    <ListItemText
                        primary="Modify"
                        secondary="Saves a workspace-only override for the workspace selected above."
                    />
                </ListItem>
                <ListItem sx={{ display: "list-item", py: 0.25, pl: 0 }}>
                    <ListItemText
                        primary="Apply for all workspaces"
                        secondary='Updates global prompt and removes all workspace overrides. Type "apply" to confirm.'
                    />
                </ListItem>
                <ListItem sx={{ display: "list-item", py: 0.25, pl: 0 }}>
                    <ListItemText
                        primary="Reset to global"
                        secondary="Removes the override for one workspace so it uses the global prompt again."
                    />
                </ListItem>
                <ListItem sx={{ display: "list-item", py: 0.25, pl: 0 }}>
                    <ListItemText
                        primary="Version history / Revert"
                        secondary='View a version before reverting. Type "revert" to confirm. Revert does not remove workspace overrides.'
                    />
                </ListItem>
            </List>
        </Alert>
    )
}
